import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Root from "./pages/root";
import { Provider } from "react-redux";
import store from "./store";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// import { AriaLiveRegion } from "./components/aria-live-region";
// eslint-disable-next-line
// import { iframeResizerContentWindow } from "iframe-resizer";

window.smuEmbedProjectMap = function (element, opts) {
    const el = element instanceof HTMLElement ? element : document.querySelector(element);
    const render = () => {
        ReactDOM.render(
            <Provider store={store}>
                <Root />
            </Provider>,
            el
        );
    };
    render();

    if (module.hot) {
        module.hot.accept("./pages/root", function () {
            render();
        });
    }
};



// WEBPACK FOOTER //
// ./src/index.js